import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { fileUploadS3TestValue } from "../../utils/constants";

export class ProofOfInsuranceField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: fileUploadS3TestValue,
      propertyName: "proofOfInsurance",
      uiFieldType: "FileUpload",
      uploadFilename: "proofOfInsurance",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const requireInsurance = this._model.merchantAccount.requireInsurance;

    if (
      (registeredCountry === "Australia" && requireInsurance) ||
      (registeredCountry === "New Zealand" && requireInsurance)
    ) {
      return true;
    }
    return false;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get required(): boolean {
    return this.applicable;
  }
}
